import { normalizeAlternateEmail } from "@/utils/alternateEmail";
import { toLanguageStrings } from "@/utils/languageRequirements";
import { websiteValue } from "@/utils/website";

const toNumber = (val) => {
  const n = parseFloat(val);
  return isNaN(n) ? null : n;
};

/**
 * Turns the review form's values into the resume-reupload submit request
 * body. Kept in its own module (rather than inline in index.jsx) so it's
 * unit-testable without pulling in the page's heavy transitive imports
 * (ResumePreview -> react-pdf, etc.) — the one rule it guards is that
 * `alternate_email` lands as a top-level key, never nested inside
 * `personal_information`.
 *
 * Languages serialize to composite strings for the same reason as
 * buildResumePayload: matching reads that list raw.
 */
export const buildReuploadSubmitPayload = (formData) => ({
  personal_information: {
    full_name: formData.personal_information.name,
    email: formData.personal_information.email,
    phone: formData.personal_information.phone,
    location: formData.personal_information.location,
    website: websiteValue(formData.personal_information.portfolio),
    linkedin: formData.personal_information.linkedin,
  },
  alternate_email: normalizeAlternateEmail(formData.personal_information.alternate_email),
  summary: formData.personal_information.summary,
  skills: formData.skills.list,
  languages: toLanguageStrings(formData.skills.languages),
  education: formData.education,
  work_experience: formData.experience.map((exp) => ({
    title: exp.jobTitle,
    company: exp.company,
    location: exp.location,
    start_date: exp.startDate,
    end_date: exp.endDate,
    description: exp.description,
    achievements: exp.achievements,
  })),
  additional_sections: [],
  current_salary: toNumber(formData.compensation?.current_salary),
  expected_salary: toNumber(formData.compensation?.expected_salary),
  notice_period: formData.compensation?.notice_period || null,
  total_experience: toNumber(formData.compensation?.total_experience),
});
